module.exports = __webpack_public_path__ + "assets/img/xlwy_c.75b8afed.png";